module.exports = __webpack_public_path__ + "static/Sonyax4d-6eb7966424f20a747bee6f20e06409a0.png";